import React from 'react';
import DTOBestPerfomer from './DTOBestPerfomer';
import BestPerfomerPresenter from './BestPerfomerPresenter';

import { useTranslation } from 'react-i18next';
function BestPerfomerController() {
  const { t } = useTranslation();

  return (
    <>
      <DTOBestPerfomer />
      <BestPerfomerPresenter trans={t} />
    </>
  );
}

export default BestPerfomerController;
